/**
 * @flow
 * @relayHash 3bf5883310f3b32cdb3cc2e90496fbbd
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type DeleteInvoiceMutationVariables = {|
  id: string
|};
export type DeleteInvoiceMutationResponse = {|
  +deleteInvoice: {|
    +id: string
  |}
|};
export type DeleteInvoiceMutation = {|
  variables: DeleteInvoiceMutationVariables,
  response: DeleteInvoiceMutationResponse,
|};
*/


/*
mutation DeleteInvoiceMutation(
  $id: String!
) {
  deleteInvoice(id: $id) {
    id
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "id",
    "type": "String!",
    "defaultValue": null
  }
],
v1 = [
  {
    "kind": "LinkedField",
    "alias": null,
    "name": "deleteInvoice",
    "storageKey": null,
    "args": [
      {
        "kind": "Variable",
        "name": "id",
        "variableName": "id"
      }
    ],
    "concreteType": "InvoiceModel",
    "plural": false,
    "selections": [
      {
        "kind": "ScalarField",
        "alias": null,
        "name": "id",
        "args": null,
        "storageKey": null
      }
    ]
  }
];
return {
  "kind": "Request",
  "fragment": {
    "kind": "Fragment",
    "name": "DeleteInvoiceMutation",
    "type": "Mutation",
    "metadata": null,
    "argumentDefinitions": (v0/*: any*/),
    "selections": (v1/*: any*/)
  },
  "operation": {
    "kind": "Operation",
    "name": "DeleteInvoiceMutation",
    "argumentDefinitions": (v0/*: any*/),
    "selections": (v1/*: any*/)
  },
  "params": {
    "operationKind": "mutation",
    "name": "DeleteInvoiceMutation",
    "id": null,
    "text": "mutation DeleteInvoiceMutation(\n  $id: String!\n) {\n  deleteInvoice(id: $id) {\n    id\n  }\n}\n",
    "metadata": {}
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '23f4d78f4c0ffc88392f2fc22c8afbb1';
module.exports = node;
